import type { HelpFile } from '../../types/help'
import { AuthLoopPageTestIds } from '../../../testids/AuthLoopPageTestIds'

export const authLoopPageHelp: HelpFile = {
  docPage: '/docs/troubleshooting/auth-loop',
  texts: {
    [AuthLoopPageTestIds.authLoopTitle]: 'You appear to be stuck in a login loop. Use the actions below to recover.',
    [AuthLoopPageTestIds.authLoopTryAgain]: 'Retry the login flow once. Cookies are kept so an existing session can resume.',
    [AuthLoopPageTestIds.authLoopLogoutFully]: 'Log out completely and clear the session, then start a fresh login from scratch.',
  },
}
